import { createContext, useContext, useEffect, useState } from "react";

export const CURRENCIES = {
  USD: { symbol: "$", rate: 1 },
  EUR: { symbol: "€", rate: 0.92 },
  GBP: { symbol: "£", rate: 0.79 },
  CAD: { symbol: "$", rate: 1.36 },
};

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem("ed_currency") || "USD");
  useEffect(() => { localStorage.setItem("ed_currency", currency); }, [currency]);

  const convert = (usd) => {
    const c = CURRENCIES[currency] || CURRENCIES.USD;
    const val = (Number(usd) || 0) * c.rate;
    const formatted = `${c.symbol}${val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    return currency === "USD" ? formatted : `${formatted} ${currency}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, convert }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}
